import type { VerdictChunk } from '@/composables/useVerdictChunks'

export const VERDICT_SOURCE_PROVIDER = 'anita' as const

export const verdictLabelTranslations = {
  en: {
    VerdictUrteilVom: 'Urteil vom',
    VerdictUnknownCourt: 'Unknown court'
  },
  de: {
    VerdictUrteilVom: 'Urteil vom',
    VerdictUnknownCourt: 'Unbekanntes Gericht'
  }
} as const

const FILE_NUMBER_MAX_LEN = 30

type Translator = (key: string) => string

export function resolveCourtName(t: Translator, court: string | null): string {
  return court && court !== 'null' ? court : t('VerdictUnknownCourt')
}

export function formatVerdictLabel(t: Translator, verdict: VerdictChunk): string {
  const parts: string[] = [resolveCourtName(t, verdict.court)]
  if (verdict.date || verdict.file_number) {
    const datePart = verdict.date ? `${t('VerdictUrteilVom')} ${verdict.date}` : ''
    const fnPart = verdict.file_number
      ? verdict.file_number.length > FILE_NUMBER_MAX_LEN
        ? verdict.file_number.slice(0, FILE_NUMBER_MAX_LEN) + '…'
        : verdict.file_number
      : ''
    const combined = [datePart, fnPart].filter(Boolean).join(' – ')
    if (combined) parts.push(combined)
  }
  return parts.join(', ')
}
